import { Button, ButtonProps } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import React from "react";
import { useStoreon } from "storeon/react";
import { ATypeEvents, ATypeState } from "../../../../store/atype-module";

const AddNewAttributeItemButton = ({ ...props }: ButtonProps) => {
    const { dispatch } = useStoreon<ATypeState, ATypeEvents>();

    const handleClick = () => {
        dispatch("atype/add/item");
    };

    return (
        <Button {...props} onClick={handleClick} startIcon={<Add />}>
            Новый тип значения
        </Button>
    );
};

export default AddNewAttributeItemButton;
